import React, { Fragment } from 'react'

const WhiteTitle = ({ title }) => {
    return (
        <Fragment>
            <span className="text-white px-2 font-title align-middle text-uppercase font-18 font-weight-bold">{title}</span>
        </Fragment>
    )
}
export default WhiteTitle;